import {FITH2GameConfig} from "../../configs/FITH2GameConfig";
import {gsap} from "gsap";
import {FITH2Helper} from "../../utils/FITH2Helper";
import {Sprite} from "pixi.js";
import {TimelineSprite} from "@nolimitcity/promo-panel/bin/utils/TimelineSprite";
import {FireInTheHole2} from "../../FireInTheHole2";

export class FreespinReelView extends PIXI.Container {

    protected _reelId: number;
    private _upgradeFrame: Sprite;
    private _upgradeAnimation: TimelineSprite;
    private _purpleCircle: TimelineSprite;
    private _container: Sprite;

    constructor(reelId: number, symId: number) {
        super();
        this.name = "Reel " + (reelId * 4 + symId);
        this._reelId = reelId * 4 + symId;
    }

    public init(): void {
        this._upgradeFrame = FITH2Helper.createSprite("freespin/fs_upgrade_cell", 0, 0);
        this._upgradeFrame.anchor.set(0.5);
        this._upgradeFrame.visible = false;
        this._upgradeFrame.blendMode = PIXI.BLEND_MODES.ADD;

        this._purpleCircle = new TimelineSprite(FireInTheHole2.assetLoader.getTextures("freespin/FX_beam_coin/FX_beam_coin_"));
        this._purpleCircle.position.set(0, 0);
        this._purpleCircle.anchor.set(0.5);
        this._purpleCircle.visible = false;
        this._purpleCircle.blendMode = PIXI.BLEND_MODES.SCREEN;

        this._upgradeAnimation = new TimelineSprite(FireInTheHole2.assetLoader.getTextures("freespin/slot_hl/slot_hl_"));
        this._upgradeAnimation.position.set(0, 0);
        this._upgradeAnimation.anchor.set(0.5);
        this._upgradeAnimation.visible = false;
        this._upgradeAnimation.blendMode = PIXI.BLEND_MODES.SCREEN;
        this.position.set(60 + FITH2GameConfig.fsSymbolWidth * (Math.floor(this._reelId / 4)), 210 + (this._reelId % 4) * FITH2GameConfig.symbolHeight);
        this._container = new PIXI.Sprite();
        this._container.name = this.name + "_spinContainer";
        //this.visible = this._reelId %4 === 1;
    }

    private addMask(): void {
        //return
        const mask: PIXI.Graphics = new PIXI.Graphics();
        mask.name = "mask" + this._reelId.toString();
        mask.beginFill(0xFF0000, 1);
        mask.drawShape(new PIXI.Rectangle(-60, -48, 120, 96));
        mask.endFill();
        this._container.addChild(mask);
        this._container.mask = mask;
    }

    public show(isRevealed: boolean = false): gsap.core.Timeline {
        this.addChild(this._upgradeFrame, this._upgradeAnimation, this._container, this._purpleCircle);
        if (!isRevealed) {
            this.addMask();
        }
        return gsap.timeline();
    }

    public hide(): gsap.core.Timeline {
        if (this._upgradeFrame) {
            this._upgradeFrame.visible = false;
        }

        if (this._upgradeAnimation) {
            this._upgradeAnimation.stopLoop();
            this._upgradeAnimation.hide();
        }
        this._container.removeChildren();
        this.removeChildren();
        return new gsap.core.Timeline();
    }

    public clearSpinContainer(isMiss: boolean): gsap.core.Timeline {
        return gsap.timeline().add(() => {
            this._container.removeChildren();
            if (isMiss) {
                this.addMask();
            }
        });
    }

    public onSideTrainSymbolLand(): void {
        this._upgradeFrame.scale.set(0.8);
        gsap.timeline().add([
            ()=>{this._upgradeFrame.visible = true;},
            gsap.to(this._upgradeFrame.scale, 0.1,{x:1, y:1}),
            gsap.to(this._upgradeFrame, 0,{alpha:1})
            ]);
    }

    public get spinContainer(): Sprite {
        return this._container;
    }

    public removeUpgradeFrameAfterHit(): void {
        gsap.timeline().add(gsap.to(this._upgradeFrame, 0.1,{alpha:0}))
            .add(()=>{this._upgradeFrame.visible = false;});
    }

    public removeUpgradeFrameSpinStart(): void {
        this._upgradeFrame.visible = false;
    }

    public removePCAnimation(delay: number): gsap.core.Timeline {
        return gsap.timeline().add(() => {
            if (this._upgradeAnimation.visible) {
                this._upgradeAnimation.stopLoop();
                this._upgradeAnimation.hide();
            }
        }, delay);
    }

    public addUpgradingPurpleEffect(): gsap.core.Timeline {
        return gsap.timeline().add([
            ()=>{this.addChild(this._purpleCircle);},
            this._purpleCircle.getAnimationAutoShowHide(true, true)
            ]);
    }

    public startPCAnimation(): gsap.core.Timeline {
        return gsap.timeline().add(() => {
            if (!this._upgradeAnimation.visible) {
                this._upgradeAnimation.show();
                this._upgradeAnimation.playLoop();
            }
        });
    }

    public getReelMultiplier(): gsap.core.Timeline {
        const tl = gsap.timeline(),
            explodeEffect: TimelineSprite = new TimelineSprite(FireInTheHole2.assetLoader.getTextures("sparkle/sparkle_"));
        explodeEffect.blendMode = PIXI.BLEND_MODES.SCREEN;
        tl.add([
            () => {
                explodeEffect.anchor.set(0.5, 0.5);
                explodeEffect.position.set(0, 0);
                this.addChild(explodeEffect);
            },
            explodeEffect.getAnimationAutoShowHide()
        ], 0);
        tl.add(() => {
            this.removeChild(explodeEffect);
        });
        return tl;
    }

    public stop(): gsap.core.Timeline {
        return gsap.timeline().add(() => {
        }, 0.01);
    }
}